import React from 'react';
import { Trans } from 'react-i18next';

export const TABS = [
  {
    mode: 'following',
    label: <Trans i18nKey="StreamTab.following"></Trans>,
  },
  {
    mode: 'recommend',
    label: <Trans i18nKey="StreamTab.recommend"></Trans>,
  },
  {
    mode: 'search',
    label: <Trans i18nKey="StreamTab.search"></Trans>,
  },
];

export const FeedRefetchInterval = 3 * 60 * 1000;

export const STREAM_TRIAL_LIMIT_CODE = 403;
